import { AssetFilterKey } from '../domain';
import { useSetFilter } from '../../filter';

export const useSetAssetListFilter = () => {
  return useSetFilter(AssetFilterKey, 'assetFilter', true);
};
